import styles from './Chip.module.css';

import { Icon } from 'components/Icon';

export interface ChipProps {
  /** Text on the chip */
  label: string;
  /** Function to remove chip from chip-list on label-text*/
  onDelete: (label: string) => void;
}

export const Chip = ({ label, onDelete }: ChipProps) => {
  return (
    <button className={styles['chip']} onClick={() => onDelete(label)}>
      <span className={styles['chip__label']}>{label}</span>
      <Icon name="Cross" size={20} className={styles['chip__close-button']} />
    </button>
  );
};
